// Карточка одной стороны сопоставления. Кликабельна только в прохождении —
// в редакторе остаётся плашкой, какой и была. Вид — порт плеерного `MatchCard`
// (academy-frontend `.../blocks/MatchCard/`): рамка 1px, скругление 16px, высота
// от 52px; высоту ряда выравнивает общая сетка `MatchBlockPreview`.
import type { CSSProperties } from 'react'
import type { QuizOptionState } from '@teach/ui'
import { blockTheme, cn } from '@teach/ui'
import { optionCardStyle } from './optionAppearance'

const CARD =
  'grid min-h-[52px] w-full grid-cols-[minmax(0,1fr)] items-center rounded-2xl border border-solid px-3 py-1.5 text-center font-semibold transition-[border-color,background-color,box-shadow,color,transform] duration-200'

// Плеер подбирает кегль из 16/14/12 (`useFitText`, до двух строк) по замеру;
// здесь замера нет — та же лестница по длине подписи.
const sizeFor = (text: string): string =>
  text.length <= 14
    ? 'text-[16px] leading-[1.25]'
    : text.length <= 34
      ? 'text-[14px] leading-[1.25]'
      : 'text-[12px] leading-[1.25]'

/** Карточка в паре до проверки — цвет пары вместо белой (плеер `pairStyle`). */
const pairStyle = (index: number): CSSProperties => {
  const pair = blockTheme.quiz.pairs[index % blockTheme.quiz.pairs.length]
  return {
    backgroundColor: pair.bg,
    borderColor: 'transparent',
    color: pair.ink,
    boxShadow: 'none',
  }
}

interface Props {
  text: string
  state: QuizOptionState
  disabled?: boolean
  /** Номер пары (0…), если карточка в паре, — по нему цвет пары. */
  pairIndex?: number
  /** Не передан — карточка статична (режим редактора). */
  onSelect?: () => void
}

export const MatchCard = ({ text, state, disabled, pairIndex, onSelect }: Props) => {
  const className = cn(CARD, sizeFor(text), state === 'incorrect' ? 'animate-oa-shake' : null)
  const style =
    state === 'idle' && pairIndex !== undefined ? pairStyle(pairIndex) : optionCardStyle(state)
  const label = <span className="[overflow-wrap:anywhere]">{text}</span>
  return onSelect ? (
    <button
      type="button"
      className={cn(className, 'active:scale-[0.97] disabled:cursor-default')}
      style={style}
      disabled={disabled}
      onClick={onSelect}
    >
      {label}
    </button>
  ) : (
    <div className={className} style={style}>
      {label}
    </div>
  )
}
